import { RequestsService } from '@/services/requests/requests.service';

const productRecommendationServiceUrl = process.env.PRODUCT_RECOMMENDATION_SERVICE_URL;

export class ProductRecommendationRepository {
  static create() {
    return new ProductRecommendationRepository(productRecommendationServiceUrl, RequestsService.create());
  }

  constructor(productRecommendationServiceUrl, request) {
    this._productRecommendationServiceUrl = productRecommendationServiceUrl;
    this._request = request;
  }

  fetchSources(customerId, token) {
    return this._request
      .get(this._getUrl(customerId), token)
      .then(this._toJsonResponse)
      .then(jsonResponse => jsonResponse.data);
  }

  _getUrl(customerId) {
    return `${this._productRecommendationServiceUrl}/api/customers/${customerId}/product-sources`;
  }

  _toJsonResponse(response) {
    if (!response.ok) {
      return response.json().then(body => Promise.reject(body));
    }

    return response.json();
  }
}
